import { z } from 'zod'
import type { ProductCategoryERPSettings } from '../../models/ProductCategoryERPSettings'

export const ProductCategoryERPSettingsDTO = z.object({
  is_required_select_product_category: z.boolean()
})

export type ProductCategoryERPSettingsDTO = z.infer<typeof ProductCategoryERPSettingsDTO>

export function mapProductCategoryERPSettingsToDTO (model: ProductCategoryERPSettings): ProductCategoryERPSettingsDTO {
  return {
    is_required_select_product_category: model.isRequiredSelectProductCategory
  }
}

export function mapDTOToProductCategoryERPSettings (dto: ProductCategoryERPSettingsDTO): ProductCategoryERPSettings {
  return {
    isRequiredSelectProductCategory: dto.is_required_select_product_category
  }
}
